
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/>    
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">            
            <Calendar v-model="dataInicio" view="month" dateFormat="mm/yy" :yearNavigator="true" :yearRange="rangeData" 
            :showIcon="true" :manualInput="false" :locale="localeCalendarBR"/>				
        </div>        
    </div>
    <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3" @click="exportarPdf"/>
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {
            dataInicio: new Date(),
            rangeData: '',
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        exportarPdf() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {               
                mesSelecionado: this.dataInicio.getMonth()+1,
                anoSelecionado: this.dataInicio.getFullYear(),
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                idsFuncionarios: idsFuncionarios,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.exportarPontoExterno(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    mounted() {
        this.criarRangeData();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
    }
}
</script>

<style>

</style>